import Vue from 'vue';

import App from './App.vue';
import Auth from './Auth.vue';
import Landing from './Landing.vue';
import Normal from './Normal.vue';

import router from './router';
import store from './store';
import api from './api';

import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

import Pusher from "pusher-js"
import Echo from "laravel-echo"

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

var bugsnagClient = bugsnag('3a438553bdb4d03bac965c107faefce6');
bugsnagClient.use(bugsnagVue, Vue);

// if (typeof(Storage) !== 'undefined' && localStorage.userId) {
if (typeof(Storage) !== 'undefined') {
    var email = null;
    var userId = null;

    if (typeof localStorage.email !== 'undefined') {
        email = localStorage.email;
    }

    if (typeof localStorage.userId !== 'undefined') {
        userId = localStorage.userId;
    }

    // bugsnagClient.user = {
    //     id: userId,
    //     email: email,
    // }
}

require('@/assets/sass/main.scss');
require('@/assets/sass/landing.scss');

window.Vue = Vue;
window.Event = new Vue();
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '6138f448e12f80c6063b',
    cluster: 'eu',
    forceTLS: true,
    // broadcaster: 'pusher',
    // key: 'c8b0f564a650b8645fc6',
    // cluster: 'eu',
    // wsHost: 'websockets.weap.io',
    // wssHost: 'websockets.weap.io',
    // wsPort: 6001,
    // wssPort: 443,
    // forceTLS: true,
    // disableStats: true,
    // enabledTransports: ['ws', 'wss'],
    authEndpoint: "https://api.weap.io/api/broadcasting/auth",
    auth: {
        headers: {
            Authorization: "Bearer " + localStorage.authenticationToken,
            Accept: "application/json",
        },
    },
});

require('@/icons.js');

Vue.config.productionTip = false

var baseTemplate = null;

// console.log(router.currentRoute);

new Vue({
    router,
    store,

    data() {
        return {
            authRelatedRoutes: ['login', 'register', 'analytics'],
            landingRelatedRoutes: ['landing'],
            normalRelatedRoutes: [
                'terms', 'privacy', 'cookie', 'children', 'digitalOceanBackups', 
                'digitalOceanHourlyBackups', 'digitalOceanDailyBackups',
            ],
        }
    },

    created() {
        this.checkLogin();
        router.beforeEach((to, from, next) => {
            this.checkLogin(to.name);
            next();
        });
    },

    render: h => h(baseTemplate),

    methods: {
        checkLogin(routeName = null) {
            if (!routeName) {
                routeName = this.$route.name;
            }

            if (this.isAuthRelatedRoute(routeName)) {
                baseTemplate = Auth;
            } else if (this.isLandingRelatedRoute(routeName)) {
                baseTemplate = Landing;
            } else if (this.isNormalRelatedRoute(routeName)) {
                baseTemplate = Normal;
            } else {
                baseTemplate = App;
            }

            this.$forceUpdate();
        },

        isAuthRelatedRoute(routeName) {
            return this.authRelatedRoutes.indexOf(routeName) !== -1;
        },

        isLandingRelatedRoute(routeName) {
            return this.landingRelatedRoutes.indexOf(routeName) !== -1;
        },

        isNormalRelatedRoute(routeName) {
            return this.normalRelatedRoutes.indexOf(routeName) !== -1;
        },
    },

}).$mount('#app');
